import Chart from 'chart.js/auto';
const chartjs = require('../../../../../../components/chart/chartjs')
const math = require('../../../../../../js-handler/math')

let barSimpleChart = null;

export function createChart(data) {
	const canvas = document.getElementById('chartPurchase');
	if (!canvas) {
		console.error("Error: No se encontró el elemento canvas con ID 'chartPurchase'");
		return;
	}

	if (canvas.clientWidth === 0 || canvas.clientHeight === 0) {
		console.warn("Advertencia: El canvas tiene dimensiones 0.");
	}

	const existingChart = Chart.getChart(canvas);
	if (existingChart) {
		existingChart.destroy();
	}

	const labelsX = data.map(p => {
		const fecha = new Date(p.year_month + '-01T00:00:00');
		return fecha.toLocaleString('default', { month: 'short', year: 'numeric' });
	});

	const metricsToGraph = [
		{ key: 'total_investment', label: 'Investment', color: 'green' },
		{ key: 'total_expenses', label: 'Expenses', color: 'blue' },
		{ key: 'total_losses', label: 'Lost', color: 'red' }
	];

	const chartData = metricsToGraph.map((m) => {
		return {
			label: m.label,
			color: m.color,
			tension: 0.4,
			borderWidth: 2,
			fill: false,
			value: data.map((periodo, i) => ({
				x: labelsX[i],
				y: parseFloat(periodo[m.key]) || 0
			}))
		};

	});

	barSimpleChart = chartjs.start({
		elem: 'line',
		act: 'createMultiple',
		targetChart: { html: canvas },
		data: chartData,
		options: {
			reponsive: true,
			maintainAspectRatio: false,
			aspectRatio: 10 / 4.1,
			legend: true,
			plugins: {
				tooltip: { enabled: true }
			},
		}
	});

}